import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { ErrorBoundary } from './ErrorBoundary';
import { Footer } from './Footer';
import { Header } from './Header';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Loading() {
  return (
    <div className='flex items-center justify-center py-16'>
      <p className='text-sm text-text-secondary'>読み込み中...</p>
    </div>
  );
}

export function Layout() {
  return (
    <div className='flex min-h-screen flex-col bg-background'>
      <ScrollToTop />
      <Header />
      <main className='mx-auto w-full max-w-[960px] flex-1 px-6 py-8'>
        <ErrorBoundary>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
      <Footer />
    </div>
  );
}
